module.exports = __webpack_public_path__ + "img/uber_logo.b4cbaf25.svg";